import { defineStore } from "pinia";
import { ref } from "vue";

export const useThemeStore = defineStore("theme", () => {
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");

  const storedTheme = ref<"dark" | "light" | "auto">(
    (localStorage.getItem("theme") as "dark" | "light" | "auto") || "auto"
  );

  const theme = ref<"dark" | "light">(
    storedTheme.value === "auto"
      ? prefersDark.matches
        ? "dark"
        : "light"
      : (storedTheme.value as "dark" | "light")
  );

  const setTheme = (newTheme: "dark" | "light" | "auto") => {
    storedTheme.value = newTheme;

    if (newTheme === "auto") {
      theme.value = prefersDark.matches ? "dark" : "light";
    } else {
      theme.value = newTheme;
    }
    localStorage.setItem("theme", storedTheme.value);
  };

  const setListener = () => {
    prefersDark.addEventListener("change", (e) => {
      if (storedTheme.value === "auto") {
        theme.value = e.matches ? "dark" : "light";
      }
    });
  };

  return {
    theme,
    storedTheme,
    setTheme,
    setListener,
  };
});
